import React from "react";
import {
  Sprout, Banknote, CalendarDays, BookOpen, Handshake, Target, Users, Building2,
  GraduationCap, Megaphone, Network, Lightbulb, Rocket, Globe, Coins, Star, Gift, Briefcase,
  HeartHandshake,
} from "lucide-react";

export const PARTNER_ICON_MAP = {
  Sprout, Banknote, CalendarDays, BookOpen, Handshake, Target, Users, Building2,
  GraduationCap, Megaphone, Network, Lightbulb, Rocket, Globe, Coins, Star, Gift, Briefcase,
  HeartHandshake,
};

export const PARTNER_ICON_NAMES = Object.keys(PARTNER_ICON_MAP);

export function PartnerIcon({ name, className = "" }) {
  const Cmp = PARTNER_ICON_MAP[name] || Handshake;
  return <Cmp className={className} />;
}
